module.exports = {"pathContext":{"slug":"/portfolio-item/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portfolio-item.json
// module id = 313
// module chunks = 114934724963867